/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/306-arrow-up-left': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M0 11.5l4-4 8.5 8.5 3.5-3.5L7.5 4l4-4H0v11.5z"/>'
  }
})
